import { gql } from 'graphql-request'

export const DOWNLOAD_BATCH = gql`
  query DownloadBatch($ids: [ID!]!) {
    downloadBatch(ids: $ids) {
      path
      link
    }
  }
`
